import React, { Component } from 'react';

class NoResults extends Component {
    render() {
        return (
            <div className="pp-no-results">
                <div className="pp-message">{this.props.message}</div>
            </div>
        );
    }
}

export default NoResults;



// WEBPACK FOOTER //
// ./src/components/NoResults.js